export default "__VITE_ASSET__NmzVFltO__"